import { useI18n } from "../i18n";
import type { Module } from "../types";

export function ComingSoon({ module }: { module: Module }) {
  const { t, pick } = useI18n();
  return (
    <div className="page">
      <div className="empty">
        <span className="badge info">
          {t("arrives")} {module.milestone}
        </span>
        <h1>{pick(module.name_en, module.name_ar)}</h1>
        <p>{module.description}</p>
        <p className="muted">{t("comingSoonBody")}</p>
      </div>
    </div>
  );
}
